import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/catalogos/plaza';

/**
 * GET Plazas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPlazas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Plazas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPlazasOptimized = async (params) => {
  try {
    const response = await API.get('/catalogos/plazas-optimized', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Plazas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPlazasvistaOptimized = async (params) => {
  try {
    const response = await API.get('/catalogos/plazas-vista-optimized', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Plaza optimizada por ID
 * @param {number} id
 * @returns {Promise<object | null>}
 */
export const getPlazavistaOptimized = async (id) => {
  try {
    const response = await API.get('/catalogos/plazas-vista-optimized', {
      params: { id },
    });

    // Si devuelve un arreglo, filtramos el que coincida con el ID
    if (Array.isArray(response.data)) {
      return response.data.find((p) => p.id === id) || null;
    }

    return response.data || null;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * GET Plaza
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPlaza = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Plaza
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPlaza = async (values) => {
  try {
    // eslint-disable-next-line no-param-reassign
    // values.clave = '1';
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Plaza
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPlaza = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Plaza
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePlaza = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Duplicar Plaza
 * @param {int} id
 * @param {int} num_copias
 * @returns {Promise<object[]>}
 */
export const duplicarPlaza = async (id, num_copias) => {
  try {
    const response = await API.get(`/catalogos/duplicar-plaza/${id}/${num_copias}`);
    onSuccess(response, 'Duplicado correctamente');
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Categorias de Puestos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCategorias = async () => {
  try {
    const response = await API.get('/catalogos/categoria-de-puesto');
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Arreglar Plazas
 * @returns {Promise<object[]>}
 */
export const getArreglarPlazas = async () => {
  try {
    const response = await API.get('/catalogos/arreglar-plazas');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * PUT Plaza Estatus Autorizada
 * @param {object} values@returns {Promise<{}>}
 */
export const putAutorizarPlaza = async (values) => {
  try {
    const response = await API.put('catalogos/actualizar-estado-plaza', values);
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Plaza Estatus Suspendida
 * @param {object} values@returns {Promise<{}>}
 */
export const putSuspenderPlaza = async (values) => {
  try {
    const response = await API.put('catalogos/actualizar-estado-plaza', values);
    onSuccess(response, 'Suspendido correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Plaza Estatus Inactiva (Inactivar)
 * @param {{ plazas: number[], fecha_efectiva: string }} values
 * @returns {Promise<{}>}
 */
export const putInactivarPlaza = async (values) => {
  try {
    const response = await API.put('catalogos/inactivar-plaza', values);
    onSuccess(response, 'Inactivado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Plaza Estatus Activa (Activar)
 * @param {{ plazas: number[], fecha_efectiva: string }} values
 * @returns {Promise<{}>}
 */
export const putActivarPlaza = async (values) => {
  try {
    const response = await API.put('catalogos/activar-plaza', values);
    onSuccess(response, 'Activado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Plaza Estatus Activa (Reactivar)
 * @param {object} values@returns {Promise<{}>}
 */
export const putReactivarPlaza = async (values) => {
  try {
    const response = await API.put('catalogos/actualizar-estado-plaza', values);
    onSuccess(response, 'Reactivado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET asignacion de plazas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getAsignacionPlazasOptimized = async (params) => {
  try {
    const response = await API.get('/catalogos/asignacion-plazas-vista-optimized', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
